export interface IConsent {
  /** Nödvändiga cookies, man kan inte svara nej men vi sparar att man svarat */
  necessary?: true;
  /** Statistik via Google analytics */
  statistics?: boolean;
  /** Felrapportering via Rollbar */
  errorReports?: boolean;
}

export const CONSENT_ALL: IConsent = {
  necessary: true,
  statistics: true,
  errorReports: true,
};

export const CONSENT_NECESSARY: IConsent = {
  necessary: true,
  statistics: false,
  errorReports: false,
};

/** Användaren har inte svarat ang. cookies */
export const CONSENT_NONE: IConsent = {};
